(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["geo-ip-popup"] && !Shopify.designMode) return;
  try {
    (function () {
    const STORAGE_KEY = 'geo_region_selection';

    function hasMadeGeoSelection() {
      try {
        return window.localStorage.getItem(STORAGE_KEY) !== null;
      } catch (e) {
        return true;
      }
    }

    function setGeoSelection(value) {
      try {
        window.localStorage.setItem(STORAGE_KEY, JSON.stringify(value));
      } catch (e) {}
    }

    function openGeoPopup(dialog) {
      if (!dialog) return;

      if (document.startViewTransition) {
        document.startViewTransition(function () {
          dialog.showModal();
        });
      } else {
        dialog.showModal();
      }
    }

    function closeGeoPopup(dialog) {
      if (!dialog.open) return;

      if (document.startViewTransition) {
        document.startViewTransition(function () {
          dialog.close();
        });
      } else {
        dialog.close();
      }
    }

    function armGeoPopupClickThroughGuard() {
      window.__geoPopupIgnoreUnderlyingClickUntil = Date.now() + 700;
    }

    function stopGeoPopupEvent(event, shouldPreventDefault) {
      if (shouldPreventDefault) event.preventDefault();
      event.stopPropagation();
      if (event.stopImmediatePropagation) event.stopImmediatePropagation();
    }

    function initGeoPopup() {
      const dialog = document.querySelector('[data-geo-popup]');
      
      if (!dialog) return;

      if (hasMadeGeoSelection()) {
        return;
      }

      openGeoPopup(dialog);
      dialog.addEventListener('cancel', function () {
        setGeoSelection({ choice: 'dismiss', ts: Date.now() });
      });

      const closeButton = dialog.querySelector('[data-geo-popup-close]');
      if (closeButton) {
        function consumeGeoPopupPress(event) {
          stopGeoPopupEvent(event, false);
        }

        function dismissGeoPopup(event) {
          stopGeoPopupEvent(event, true);
          setGeoSelection({ choice: 'dismiss', ts: Date.now() });
          armGeoPopupClickThroughGuard();
          closeGeoPopup(dialog);
        }

        closeButton.addEventListener('pointerdown', consumeGeoPopupPress);
        closeButton.addEventListener('mousedown', consumeGeoPopupPress);
        closeButton.addEventListener('touchstart', consumeGeoPopupPress);
        closeButton.addEventListener('click', dismissGeoPopup);
      }

      let form = dialog.querySelector('[data-geo-popup-form]');
      if (!form) {
        form = dialog.querySelector('form');
      }

      const selectTrigger = dialog.querySelector('[data-geo-popup-select-trigger]');
      const submitButton = dialog.querySelector('[data-geo-popup-submit]');
      const countryList = dialog.querySelector('[data-geo-popup-country-list]');
      const countryCodeInput = dialog.querySelector('[data-geo-popup-country-code]');
      const countryItems = Array.from(dialog.querySelectorAll('[data-country-code]'));
      const selectedName = dialog.querySelector('.geo-popup__selected-name');
      const selectedFlag = dialog.querySelector('.geo-popup__country-select .geo-popup__country-flag');

      function closeCountryList() {
        if (!selectTrigger || !countryList) return;
        selectTrigger.setAttribute('aria-expanded', 'false');
        countryList.hidden = true;
        selectTrigger.classList.remove('is-open');
      }

      function openCountryList() {
        if (!selectTrigger || !countryList) return;
        selectTrigger.setAttribute('aria-expanded', 'true');
        countryList.hidden = false;
        selectTrigger.classList.add('is-open');
      }

      function toggleCountryList() {
        if (!selectTrigger || !countryList) return;
        if (countryList.hidden) {
          openCountryList();
        } else {
          closeCountryList();
        }
      }

      function selectGeoCountry(item) {
        const countryCode = item.dataset.countryCode;
        const countryName = item.querySelector('.geo-popup__country-name')?.textContent;
        const countryFlagStyle = item.querySelector('.geo-popup__country-flag')?.getAttribute('style');

        if (!countryCode || !countryCodeInput) return;

        countryCodeInput.value = countryCode;
        countryItems.forEach((countryItem) => countryItem.classList.remove('is-selected'));
        item.classList.add('is-selected');
        if (selectedName && countryName) selectedName.textContent = countryName;
        if (selectedFlag && countryFlagStyle) selectedFlag.setAttribute('style', countryFlagStyle);
        closeCountryList();
      }

      if (selectTrigger) {
        selectTrigger.addEventListener('click', toggleCountryList);
      }

      dialog.addEventListener('click', function (event) {
        if (!dialog.contains(event.target)) return;
        if (selectTrigger && selectTrigger.contains(event.target)) return;
        if (countryList && !countryList.hidden) {
          closeCountryList();
        }
      });

      function isolateGeoPopupEvent(event) {
        event.stopPropagation();
      }

      function isolateGeoPopupBackdropEvent(event) {
        if (!dialog.open || event.target !== dialog) return;
        event.stopPropagation();
        if (event.stopImmediatePropagation) event.stopImmediatePropagation();
      }

      ['pointerdown', 'mousedown', 'touchstart', 'pointerup', 'mouseup', 'touchend', 'click', 'keydown', 'submit', 'cancel'].forEach(
        (eventName) => {
          dialog.addEventListener(eventName, isolateGeoPopupEvent);
        }
      );

      ['pointerdown', 'mousedown', 'touchstart', 'pointerup', 'mouseup', 'touchend', 'click'].forEach((eventName) => {
        window.addEventListener(eventName, isolateGeoPopupBackdropEvent, true);
        document.addEventListener(eventName, isolateGeoPopupBackdropEvent, true);
      });

      function isolateGeoPopupSubmitPress(event) {
        if (!submitButton || !event.target || !submitButton.contains(event.target)) return;
        // Isolate the press from underlying page handlers, but never
        // preventDefault so the native localization form submission proceeds.
        event.stopPropagation();
        if (event.stopImmediatePropagation) event.stopImmediatePropagation();
      }

      if (submitButton) {
        ['pointerdown', 'mousedown', 'touchstart', 'pointerup', 'mouseup', 'touchend', 'click'].forEach((eventName) => {
          window.addEventListener(eventName, isolateGeoPopupSubmitPress, true);
          document.addEventListener(eventName, isolateGeoPopupSubmitPress, true);
        });
      }

      countryItems.forEach((item) => {
        item.addEventListener('click', () => selectGeoCountry(item));
        item.addEventListener('keydown', (event) => {
          if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            selectGeoCountry(item);
          }
        });
      });

      if (form) {
        form.addEventListener('submit', function () {
          // Record the selection, then let the localization form submit
          // natively so the customer's chosen country/market is applied.
          setGeoSelection({ choice: 'accepted', ts: Date.now() });
        });
      }
    }

    document.addEventListener('DOMContentLoaded', initGeoPopup);
  })();
  } catch(e) { console.error(e); }
})();

})();
